import {CheckOutlined, ClockCircleOutlined, CloseOutlined} from '@ant-design/icons';
import {TagProps} from 'antd/es/tag';
import {SettlementFieldsFragment, SettlementStatus} from 'api/generated';
import {StatusTag} from 'components/StatusTag';
import {colors} from 'lib/colors';
import React from 'react';

interface Props extends TagProps {
  payout: SettlementFieldsFragment;
}

export const PayoutStatusTag: React.FC<Props> = ({payout, ...props}) => {
  switch (payout.status) {
    case SettlementStatus.PENDING:
      return (
        <StatusTag {...props} color={colors.grey}>
          Pending <ClockCircleOutlined />
        </StatusTag>
      );
    case SettlementStatus.SUSPENDED:
      return (
        <StatusTag {...props} color={colors.error}>
          Suspended <CloseOutlined />
        </StatusTag>
      );
    case SettlementStatus.COMPLETED:
      return (
        <StatusTag {...props} color={colors.success}>
          Completed <CheckOutlined />
        </StatusTag>
      );
  }

  return null;
};
